import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Base64 } from 'base64-string';
import { MessageService } from "primeng/api";
import { filter, Observable, switchMap } from "rxjs";
import { DeleteCautionModalComponent } from "../../../components/modal-templates/delete-caution-modal/delete-caution-modal.component";
import { DeleteConfirmationComponent } from "../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { EditorItemModalComponent } from "../../../components/modal-templates/generic-modal/editor-item-modal.component";
import { SharedImports } from "../../../components/shared.module";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import {
  selectAutomationError,
  selectLoading,
  selectUiObjects
} from "../../../core/ngrx/selectors/automation.selectors";
import { uiObjectDeleteTableColumns } from "../../../core/table-templates/application-delete-caution-table";
import { automationPageTableColumn } from "../../../core/table-templates/automation-page-table";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-page",
  standalone: true,
  imports: [CommonModule, ...SharedImports,DeleteConfirmationComponent],
  templateUrl: "./page.component.html",
  styleUrl: "./page.component.scss",
})
export class PageComponent extends BaseLayoutComponent {
  @Input() tableData: any = [];
  private messageService = inject(MessageService);

  uiObjects$!: Observable<any>;
  pages$!: Observable<any>;
  automationProject$!: Observable<any>;
  applications$!: Observable<any>;
  loading$!: Observable<any>;
  error$!: Observable<any>;
  columns: any = automationPageTableColumn;

  private modalService = inject(NgbModal);

  projectID!: string;
  automationProjectID!: string;
  applicationId!: string;
  page: any;
  selectedTableItem: any;
  iconSrcDelete: string =
    "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  selectedObjects: any = [];
  isLoading:boolean = false;
  isMobileType = false;

  ngOnInit() {
    console.log(this.dataStore.activeNode);
    let parentNode = this.dataStore?.activeNode?.parent;
    if(parentNode.type === this.dataStore.activeNode.type && parentNode.parent) {
      parentNode = parentNode.parent;
    }
    if(parentNode.paradigm?.toLowerCase() === 'mobile') {
      this.isMobileType = true;
    }
    this.projectService.getApplicationId().subscribe((id: any) => {
      this.applicationId = id;
    });

    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectID = id;
    });

    this.projectService.getProjectId().subscribe((id) => {
      if (id != null) {
        this.projectID = id;
      }
    });

    this.uiObjects$ = this.projectService.getPageId().pipe(
      filter((id: any) => !!id),
      switchMap((id: string) => this.store.select(selectUiObjects(id)))
    );

    this.automatiCScriptService.getActiveNode().subscribe((item: any) => {
      if (item.type === "pages") {
        this.page = item;
        this.paramTableData(item);
      }
    });

    this.uiObjects$.subscribe((data: any) => {
      this.paramTableData(data);
    });

    this.loading$ = this.store.select(selectLoading);
    this.error$ = this.store.select(selectAutomationError);
  }

  //add locators to children of ui object
  paramTableData(item: any) {
    let rowData: any[] = [];
    const enc = new Base64();
    if (item?.type === "pages") {
      let newObj = {};
      item?.uiObjects?.forEach((element: any) => {
        newObj = {
          children: element?.locators.map((item:any) => ({
            ...item,
            locator: this.isBase64(item?.locator,enc) ?  enc.decode(item?.locator) : item?.locator
          })),
          ...element,
        };
        rowData.push(newObj);
      });
    } else {
      let newObj = {};

      item.forEach((element: any) => {
        newObj = {
          children: element?.locators?.map((item:any) => ({
            ...item,
            locator: enc.decode(item?.locator)
          })),
          ...element,
        };
        rowData.push(newObj);
      });
    }

    this.tableData = rowData;
  }

  //handle table actions
  handleTableActions(event: any) {
    console.log("Event==>", event);
    switch (event?.type) {
      case "conditional-button":
        this.addUpdateUiObjectLocator(event?.data?.row, false,event?.data?.column?.key);
        break;

      //delete locators
      case "conditional-svg":
        this.removeUiObject([event?.data?.row?.parent?.id], true, event?.data?.row);      
        break;

      case "svg":
        if (event?.data?.row?.level == 0) {
          //edit ui object name
          const fields = [
            {
              name: "UI Object Name",
              dataType: "string",
              id: "name",
              placeholder: "UI Object Name",
            },
          ];
          this.openGenericModal(true, event?.data?.row, fields,event?.data?.column?.key);
        } else {
          //add, update locators
          this.addUpdateUiObjectLocator(event?.data?.row, true,event?.data?.column?.key);
        }
        break;
      default:
        break;
    }
  }

  //add locators, remove test case/locators
  addUpdateUiObjectLocator(data: any, isEdit: boolean,actionData:any) {
    let fields = [
      {
        name: "Locator",
        type: "text-input",
        id: "locator",
        placeholder: "Locator X-path",
        validations: {
          required: true,
        },
      },
      {
        name: "Locator Browser Type",
        dataType: "browser",
        id: "type",
        placeholder: "Locator Browser Type",
      },
    ];

    let fieldsEdit: any = [
      {
        name: "Locator",
        type: "text-input",
        id: "locator",
        value: data?.locator,
        placeholder: "Locator X-path",
        validations: {
          required: true,
        },
      },
      {
        name: "Locator Browser Type",
        dataType: "browser",
        id: "type",
        placeholder: "Locator Browser Type",
        value: data?.type,
        isDisabled: true,
      },
    ];


    if(this.isMobileType) {
      fields = [
        {
          name: "Locator",
          type: "text-input",
          id: "locator",
          placeholder: "Locator X-path",
          validations: {
            required: true,
          },
        },
        {
          name: "Platform",
          dataType: "mobileplatform",
          id: "type",
          placeholder: "Platform Type",
        }
      ];

      fieldsEdit = [
        {
          name: "Locator",
          type: "text-input",
          id: "locator",
          value: data?.locator,
          placeholder: "Locator X-path",
          validations: {
            required: true,
          },
        },
        {
          name: "Platform",
          dataType: "mobileplatform",
          id: "type",
          placeholder: "Platform Type",
          value: data?.type,
          isDisabled: true,
        }
      ];
    }
    
    const modalParams = {
      title: isEdit ? "Update Object Locator" : "Add Object Locator",
      saveBtnText: "Add",
      isEdit: isEdit,
    };

    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = modalParams;
    if (fields) {
      modalRef.componentInstance.fields = isEdit ? fieldsEdit : fields;
    }
    modalRef.result.then((result: any) => {
      let locators: any[] = [];

      // Check if a locator with the same type already exists
      const isTypeExists = this.checkIfExists(
        this.tableData,
        data,
        result,
        isEdit
      );
      const enc = new Base64();
      if (!isTypeExists) {
        this.selectedTableItem?.children?.forEach((element: any) => {
          locators.push(element);
        });
        locators.push(result.value);

        let newData = {
          name: data.name,
          locators: locators.map((item:any) => ({
            ...item,
            locator: enc.encode(`${item?.locator}`),
          }))
        };

        if (isEdit) {
       
          const oldLocators = data?.parent?.children.map((item:any) => ({
            ...item,
            locator: this.isBase64(item?.locator,enc) ? item?.locator : enc.encode(`${item?.locator}`),
          }));
        
          const selectedLocator = {
            type: data?.type,
            locator:this.isBase64(data?.locator,enc) ?  data?.locator : enc.encode(`${data?.locator}`)
          };
          const newLocator = {
            type: data?.type,
            locator: this.isBase64(result?.value?.locator,enc) ?  result?.value?.locator : enc.encode(`${result?.value?.locator}`)
          };
          // Replace selectedLocator with newLocator if it exists in oldLocators
          const updatedLocators = oldLocators.map((locator: any) =>
            locator.type === selectedLocator.type && locator.locator === selectedLocator.locator
              ? { ...locator, locator: newLocator.locator }
              : { ...locator }
          );
          newData = {
            name: data?.parent?.name,
            locators: updatedLocators,
          };
        }
        console.log(result);
        this.store.dispatch(
          AutomationActions.updateUiObject({
            projectId: this.projectID,
            automationProjectId: this.automationProjectID,
            applicationId: this.applicationId,
            pageId: this.page.id,
            id: isEdit ? data?.parent?.id : data?.id,
            changes: newData,
            action: actionData
          })
        );
      } else {
        this.toaster.pop({ type: 'error', text: MessageEnum.LOCATOR_DUPLICATE_WARNING });
      }
    });
  }

  isBase64(str: string, enc: any): boolean {
    // Basic validation: must match base64 pattern and length must be divisible by 4
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
  
    if (!str || str.length % 4 !== 0 || !base64Regex.test(str)) {
      return false;
    } 
  
    try {
      enc.decode(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  //check if same type locators exists in the ui object
  checkIfExists(
    tableData: any[],
    data: any,
    result: any,
    isEdit: boolean
  ): boolean {
    let id = isEdit ? data?.parent?.id : data?.id;
    this.selectedTableItem = tableData?.find((item) => item?.id === id);

    if (isEdit) {
      return false;
    }
    if (this.selectedTableItem) {
      return this.selectedTableItem?.locators?.some(
        (locator: any) => locator?.type === result?.value?.type
      );
    } else {
      return false;
    }
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }

  handleRowSelect(event: any) {
    this.selectedObjects = event?.data;
  }

  removeUiObjectConfirmation() {
    this.isLoading = false;
    //delete ui object / bulk
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      centered: true,
      size: "sm",
      backdrop: "static",
    });
    modalRef.result.then((result: any) => {
      if (result) {
        this.store.dispatch(
          AutomationActions.deleteUiObjects({
            pageId: this.page.id,
            projectId: this.projectID,
            automationProjectId: this.automationProjectID,
            applicationId: this.applicationId,
            idList: this.selectedObjects.map((item: any) => item.id),
          })
        );
      }
    });
  }

  removeUiObject(ids?: any[], isLocatorValidator?: boolean, param?: any) {
    this.isLoading = true;

    let idList = ids ? ids : this.selectedObjects.map((item: any) => item.id);

    this.restService
      .deleteValidationUiObject(
        this.projectID,
        this.automationProjectID,
        this.applicationId,
        this.page.id,
        idList
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          let rowData = response?.data;
          rowData = this.assignLevels(rowData);
          let deletableIds: any = [];
          
          if(!isLocatorValidator) {
            deletableIds = this.selectedObjects
            .filter((item: any) => !rowData?.some((d: any) => d.id === item.id))
            .map((item: any) => item.id);
          }

          const data = {
            deleteList: deletableIds,
            skippedList: rowData,
          };
          if (
            Array.isArray(data?.skippedList) &&
            data?.skippedList?.length > 0
          ) {
            this.removeUiObjectCaution(data, isLocatorValidator);
          } else {
            if(isLocatorValidator) {
              this.UiLocatorDeleteConfirmation(param);
            } else {
            this.removeUiObjectConfirmation();
            }
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.toaster.pop({ type: 'error', text: MessageEnum.AUTOMATION_UI_OBJECT_DELETE_VALIDATION_FAILURE });
        },
      });
  }

  UiLocatorDeleteConfirmation(row: any) {
    const enc = new Base64();
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      centered: true,
      size: "sm",
      backdrop: "static",
    });
    modalRef.result.then((result: any) => {
      if (result) {
        let locators: any[] = [];
        row?.parent?.children.forEach((element: any) => {
          locators.push(element);
        });

        locators = locators.filter(
          (locator) =>
            !(
              locator.locator === row?.locator &&
              locator.type === row?.type
            )
        );

       const locatorsNew = locators?.map((item:any) => ({
          ...item,
          locator: this.isBase64(item?.locator,enc) ? item?.locator : enc.encode(`${item?.locator}`),
        }));

        let newData = {
          name: row?.parent?.name,
          locators: locatorsNew,
        };

        this.store.dispatch(
          AutomationActions.updateUiObject({
            projectId: this.projectID,
            automationProjectId: this.automationProjectID,
            applicationId: this.applicationId,
            pageId: this.page.id,
            id: row?.parent?.id,
            changes: newData,
            action : row.column?.key
          })
        );
      }
    });
  }

  assignLevels(data: any[], level: number = 0): any[] {
    return data.map(item => {
      const hasScript = this.containsScript(item);
      const newItem = {
        ...item,
        level,
        scriptLevel: hasScript
      };
  
      if (item.children && item.children.length > 0) {
        newItem.children = this.assignLevels(item.children, level + 1);
      }
  
      return newItem;
    });
  }
  
  containsScript(item: any): boolean {
    if (item.script) {
      return true;
    }else{
      return false;
    }
  }

  removeUiObjectCaution(tableData: any, isLocatorValidator?: boolean) {
    this.isLoading = false;
    let nonDeletableAppCount = tableData.skippedList.length;
    let modalRef = this.modalService.open(DeleteCautionModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });
    modalRef.componentInstance.configs = {
      subTitle: isLocatorValidator ? 'Unable to Delete Selected Locator' : "Unable to Delete All Selected Ui Objects",
      cautionMessage1: isLocatorValidator ? 'Selected ui objects is currently used in test scripts. To avoid breaking existing tests, these ui objects or locators cannot be deleted.' :
        nonDeletableAppCount +
        " of the selected ui objects are currently used in test scripts. To avoid breaking existing tests, these ui objects cannot be deleted.",
      cautionMessage2: isLocatorValidator ? '' : "Only ui objects that are not currently in use will be removed.",
      footerMessage1: isLocatorValidator ? '' : "You can delete the remaining ui objects that are not used in any scripts.",
      footerMessage2:
        isLocatorValidator ? 'To delete the selected ui object or locators, first remove their references from the test scripts mentioned above.' : "To delete the listed ui objects, first remove their references from the test scripts mentioned above.",
      tableData: tableData.skippedList,
      tableTitle: "Details of Ui Objects in Use",
      deleteButtonText: isLocatorValidator ? '' : (tableData.deleteList?.length ? "Delete Unused Ui Objects Only" : ''),
      columns: uiObjectDeleteTableColumns,
      projectId:this.projectID,
      automationProjectId:this.automationProjectID,
    };
    modalRef.result.then((result) => {
      if (result) {
        //delete pages / bulk
        this.store.dispatch(
          AutomationActions.deleteUiObjects({
            pageId: this.page.id,
            projectId: this.projectID,
            automationProjectId: this.automationProjectID,
            applicationId: this.applicationId,
            idList: tableData.deleteList
          })
        );
      }
    });
  }

  addNewUiObject() {
    const fields = [
      {
        name: "UI Object Name",
        dataType: "string",
        id: "name",
        placeholder: "UI Object Name",
      },
    ];

    this.openGenericModal(false, {}, fields,{});
  }

  openGenericModal(isEdit: boolean, row: any, fields: any,actionData:any) {
    const modalParams = {
      title: isEdit ? "Update UI Object" : "Add New UI Object",
      saveBtnText: "Add",
      isEdit: isEdit,
    };

    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = modalParams;
    if (isEdit) {
      const fieldsData = fields.map((field: any) => {
        return {
          ...field,
          value: row[field.id] || "",
        };
      });
      modalRef.componentInstance.fields = fieldsData;
    } else {
      modalRef.componentInstance.fields = fields;
    }
    modalRef.result.then((result: any) => {
      if (this.checkIfObjectExists(result?.value?.name)) {
        this.toaster.pop({ type: 'error', text: MessageEnum.UI_OBJECT_NAME_DUPLICATE });
      } else {
        if (isEdit) {
          let newData = {
            name: result?.value?.name,
            locators: row?.locators,
          };
          this.store.dispatch(
            AutomationActions.updateUiObject({
              projectId: this.projectID,
              automationProjectId: this.automationProjectID,
              applicationId: this.applicationId,
              pageId: this.page?.id,
              id: row?.id,
              changes: newData,
              action: actionData
            })
          );
        } else {
          this.store.dispatch(
            AutomationActions.addUiObject({
              projectId: this.projectID,
              automationProjectId: this.automationProjectID,
              applicationId: this.applicationId,
              pageId: this.page?.id,
              uiObject: {
                name: result?.value?.name,
                locators: [],
              },
            })
          );
        }
      }
    });
  }

  checkIfObjectExists(name: string): boolean {
    return this.tableData.some((element: any) => element.name === name);
  }

  refreshData() {
    this.store.dispatch(
      AutomationActions.loadUiObjects({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        applicationId: this.applicationId,
        pageId: this.page?.id,
      })
    );
  }
}
